import NProgress from 'nprogress';
import services from './services';
import {
    lg,
    cloneDeep,
    util,
    isCorrectVal,
    isDate
} from 'utils';
import $http from '$http';
// import paymentHistoryListDialog from '@pages/CRMAgentAccountManage/components/paymentHistoryListDialog/index.vue'; //旧的
import borrowHistoryListDialog from '@pages/CRMAgentAccountManage/components/borrowHistoryListDialog/index.vue';
import changeMoneyDialog from '@pages/CRMAgentAccountManage/components/changeMoney/index.vue'; //修改金额
import returnMoneyDialog from '@pages/CRMAgentAccountManage/components/returnMoney/index.vue'; //还款/认款金额
import paymentHistoryListDialog from '@pages/Agent/AgentLend/components/paymentHistoryListDialog/index.vue';
//组件
export default {
    components: {
        paymentHistoryListDialog,
        borrowHistoryListDialog,
        changeMoneyDialog,
        returnMoneyDialog,
    },
    props: {},
    mixins: [services],
    data() {
        return {
            opts: {},
            isUpdate: false, //修改为true,查看为false
            dialogVisible: false,
            form: {},
            title: "",
            dialogQuestionVisible: false, //联帮在线Q4配套资源包疑问弹窗
            messageTip: '', //弹窗文本内容
            isOne: true, //app智趣坞提示信息区分
            BookEduListApp: [], //智趣坞APP教育账户（独家）自定义数据格式
            isQ4List: false,
            isBookEduList: false,
            HiBList: [], //Hi幼教B政策（2017Q3）押金账户情况
            isHiB: false,
            isApp: false,
        }
    },
    computed: {

    },
    methods: {
        getErpConfig() {
            return cloneDeep({
                agentId: "",
                isUpdate: false,
            });
        },

        show(options) {
            this.dialogVisible = true
            let opts = $.extend({}, this.getErpConfig(), options);
            this.isUpdate = opts.isUpdate;
            if (this.isUpdate) {
                this.title = "修改"
            } else {
                this.title = "查看"
            }
            this.opts = opts;
            this.getInitData(opts.agentId);
        },
        //确定修改
        updateFn() {
            this.dialogVisible = false;
            this.$emit('reloadList'); // 向上派发 toggle事件

        },
        //还款记录
        payHistoryFn(item) {
            this.$refs.refpaymentHistoryListDialog.show({
                LendId: 0,
                AgentId: this.opts.agentId,
                ProjectType: item.ProjectType,
                AccountType: item.AccountType
            });
        },
        //借款记录
        borrowHistoryFn(item) {
            console.log(item)
            this.$refs.refborrowHistoryListDialog.show({
                AgentId: this.opts.agentId,
                ProjectType: item.ProjectType,
                AccountType: item.AccountType
            });
        },
        //修改金额
        changeMoneyFn(item) {
            this.$refs.refchangeMoneyDialog.show({
                data: item,
                AgentId: this.opts.agentId
            });
        },
        //还款、认款金额
        confirmMoneyFn(item) {
            this.$refs.refreturnMoneyDialog.show({
                data: item,
                AgentId: this.opts.agentId,
                title: "认款"
            });
        },
        returnMoneyFn(item) {
            this.$refs.refreturnMoneyDialog.show({
                data: item,
                AgentId: this.opts.agentId,
                title: "还款"
            });
        },
        closeCallback() {
            this.$emit('reloadList'); // 向上派发 toggle事件
            this.Form = {};
            this.upTotalHiPrePayMoney = 0;
            this.upTotalAccountBalance = 0;
        },
        //疑问弹窗
        dialogQuestion(val) {
            if (val == 'Q4') {
                this.isOne = true;
                this.messageTip = '此资源包套数为，2017 Q4会销套餐所含的下册书籍需要到2018年发货，先统计各代理商名下园所的下单时获赠的学习材料包。'
            } else if (val == 'erp') {
                this.isOne = true;
                this.messageTip = '该账户为ERP的大商下单统计应收款，应收款分为本期应收和二期应收款和已付合同款。'
            } else {
                this.isOne = false;
            }
            this.dialogQuestionVisible = true;
        }
    }
};


// WEBPACK FOOTER //
// ./src/pages/CRMAgentAccountManage/components/agentAccountManageDialog/vm.js